import { styled } from "@mui/system";
import { Paper } from "@mui/material";

export const StyledButtonGroupHolder = styled(Paper)(() => ({
  height: "64px",
  display: "flex",
  alignItems: "center",
  padding: "20px",
}));
